import { render, staticRenderFns } from "./ShareBlack.vue?vue&type=template&id=bc6b8daa&scoped=true"
var script = {}
import style0 from "./ShareBlack.vue?vue&type=style&index=0&id=bc6b8daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6b8daa",
  null
  
)

export default component.exports